import { BrandColorType, MiscStateType } from 'src/shared/types/src';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: MiscStateType = {
    hardRefreshApp: false,
    refreshLastObservation: false,
    showDownloadAppBanner: true,
    isFileDownloading: false,
    themeColors: {
        dark: {} as BrandColorType,
        light: {} as BrandColorType
    }
}

const miscSlice = createSlice({
    name: 'miscSlice',
    initialState,
    reducers: {
        setHardRefresh: (state, action: PayloadAction<{ hardRefresh: boolean }>) => {
            state.hardRefreshApp = action.payload.hardRefresh
        },
        setLastObservationRefresh: (state, action: PayloadAction<{ refresh: boolean }>) => {
            state.refreshLastObservation = action.payload.refresh;
        },
        setShowDownloadAppBanner: (state, action: PayloadAction<{ showDownloadAppBanner: boolean }>) => {
            state.showDownloadAppBanner = action.payload.showDownloadAppBanner;
        },
        setThemeColors: (state, action: PayloadAction<MiscStateType['themeColors']>) => {
            state.themeColors = action.payload;
        }
    }
});

export const MiscActions = miscSlice.actions;
export default miscSlice.reducer;
